import React from 'react';
import { motion } from 'framer-motion';
import { Camera, Send, Search, FileText, CheckCircle } from 'lucide-react';
const steps = [{
  icon: Camera,
  title: '1. Sacale una foto',
  description: 'Tomá una foto clara de tus dólares dañados.'
}, {
  icon: Send,
  title: '2. Enviala por WhatsApp',
  description: 'Mandanos la foto de forma rápida y segura.'
}, {
  icon: Search,
  title: '3. Evaluamos el estado',
  description: 'Revisamos el billete para determinar su valor.'
}, {
  icon: FileText,
  title: '4. Recibí cotización',
  description: 'Te enviamos una oferta justa en minutos.'
}, {
  icon: CheckCircle,
  title: '5. Coordinamos',
  description: 'Si aceptás, arreglamos la operación al instante.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-white relative" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-76">
        <div className="text-center mb-16" data-id="element-77">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0a2540] mb-4" data-id="element-78">
            ¿Cómo funciona?
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-79">
            Un proceso simple, rápido y transparente para cambiar tus billetes
            dañados.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-80">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-slate-50 border border-slate-200 rounded-2xl p-6 hover:border-blue-500 hover:shadow-md transition-all duration-300 group" data-id="element-81">
              <div className="w-12 h-12 rounded-full bg-white border border-slate-100 flex items-center justify-center mb-4 group-hover:bg-blue-50 transition-colors duration-300 shadow-sm" data-id="element-82">
                <step.icon className="w-6 h-6 text-slate-500 group-hover:text-blue-700 transition-colors duration-300" data-id="element-83" />
              </div>
              <h3 className="text-lg font-semibold text-[#0a2540] mb-2" data-id="element-84">
                {step.title}
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed" data-id="element-85">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}